import React from 'react';
import { sortCitiesByYearPopulationGrowth, getDotPosition, GROWTH_YEAR } from '../../../helpers';
import './index.scss';
import mapSize from '../../../settings/mapSize.json';
import { getText } from '../../../texts';
import { data } from '../../../data';

interface MapPrps {
  cities: typeof data.cities;
  showCityView: (index: number) => void;
}

const Map: React.FC<MapPrps> = ({ cities, showCityView }) => {
  /**
   * Growth statistic taken by last 5 years
   */
  const citiesGrowthSorted = sortCitiesByYearPopulationGrowth(cities, GROWTH_YEAR);
  const getCityGrowthIndex = (city) => citiesGrowthSorted.indexOf(city) + 1;

  return (
    <div className="map">
      {cities.map((city, index) => (
        <div key={`map-city-${city.id}`} className="dot" style={getDotPosition(city.coordinates as [number, number])}>
          {`#${index + 1}`}
          <div
            className={`tooltip city-info${city.coordinates[0] > mapSize.width / 2 ? ' left' : ''}${
              city.coordinates[1] > mapSize.height / 2 ? ' top' : ''
            }`}
          >
            <h5 className={`font-accent ${city.id}`}>{city.full_name}</h5>
            <p className="tooltip-title">
              {getText('info_title', { city: city.full_name, rank: getCityGrowthIndex(city) })}
            </p>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                showCityView(index);
              }}
            >
              {getText('more_info')}
            </a>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Map;
